import React, { useState, useEffect ,useLayoutEffect,useRef} from 'react';
import { Button } from "../atoms/button";
import useMedia from 'use-media';
import image_base from '../../resources/image/GrandeeHamanako2.jpg';
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { InputConfirm } from "../molecules/inputConfirm";
import { InputConfirmReserver } from "../molecules/inputConfirmReserver";
import { InputConfirmStartTime } from "../molecules/inputConfirmStartTime";
import { InputConfirmUndecided } from "../molecules/inputConfirmUndecided";
import { PlanListConfirm } from "../molecules/planListConfirm";
import { Confirmheader } from "../molecules/confirmheader";
import { Line } from '../atoms/line';
import { GolfFooterContainer } from "../organisms/golfFooterContainer";
import { Label } from '../atoms/label';
import { requestReserveApi, reserveApi ,versionGetApi} from "../../const";
import { connect,useStore } from "react-redux";
import common from "../../resources/js/common/common"
import { apiKeyCheck } from '../../const';
import { useRtoaster } from '../../hooks/useRtoaster';

const GolfConfirmContainer = (props) => {
    const { facility, 
            plan, 
            playDate1, 
            group, 
            teeTimeList, 
            reserver, 
            login, 
            reserveCheckInfo,
            kaiinken,
            course,
            changeReserveNo,
            reserveType,
            golfLocation
        } = props;

    const history = useHistory();
    const store = useStore();


    const [golfArea, setGolfArea] = useState("");
    const [planName, setPlanName] = useState("");
    const [playDate, setPlayDate] = useState("");
    const [groupNumber, setGroupNumber] = useState("");
    const [teeTimes, SetTeeTimes] = useState([]);
    const [errorMessage, setErrorMessage] = useState(true);
    const [reserveChangeErrorMessage, setReserveChangeErrorMessage] = useState(true);
    const [otherCourseCheck, setOtherCourseCheck] = useState(true);

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);

    const processing = useRef(false);

    // rtoasterタグ生成
    let customParam = {};
    if (reserveCheckInfo.length !== 0) {
        let jsonTxt = reserveCheckInfo.reservationsDayInformationList[0].ntgGeneralPurposeItem;
        let jsonObj = JSON.parse(jsonTxt);
        const contractNo = jsonObj.ResortTrustInfomation.ownerMemberCode;
        const riyoDate = new Date(reserveCheckInfo.playDate);
        const facilityCd = course?.length ? course.find(value => value.id == reserveCheckInfo.golfCourseID)?.facilityCd : "";

        customParam = {
            "sisetucd": facilityCd,
            "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
            "keiyakuno": contractNo,
            "packcd": plan.planid,
            "packnam": plan.planname,
            "coursecd": teeTimeList?.map(value => { return value.courseID })?.join(","),
            "startjikan": teeTimeList?.map(value => { return value.teeTime })?.join(","),
        }
    } else {
        const riyoDate = new Date(playDate1);
        let contractNo = "";
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                contractNo = data.contractNo;
            }
        });
        customParam = {
            "sisetucd": course.find(value => value.id == plan.golfCourseID)?.facilityCd,
            "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
            "keiyakuno": contractNo,
            "packcd": plan.planid,
            "packnam": plan.planname,
            "coursecd": teeTimeList?.map(value => { return value.courseID })?.join(","),
            "startjikan": teeTimeList?.map(value => { return value.teeTime })?.join(","),
        }
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){   
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
        common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if(!res.data){
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
    }

    
    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);

        if(changeReserveNo !== undefined && changeReserveNo !== null && changeReserveNo !== ""){
            setGolfArea(reserveCheckInfo.golfCourseName);
        }else{
            setGolfArea(facility.name);
        }
        setPlanName(plan.planname);

        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        var playDate;
        //予約変更
        if(reserveCheckInfo.length !== 0 && reserveCheckInfo.MemberCode !== undefined){
            playDate = new Date(reserveCheckInfo.playDate);
        }else{
            playDate = new Date(playDate1);
        }
        const y = playDate.getFullYear();
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();
        setPlayDate(`${y}年${m}月${d}日(${youbi[playDate.getDay()]})`);
        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id);
        });

        // setGroupNumber(groupNumber);
        //検索で入力された組数ではなく入力された組数をセット
        setGroupNumber(teeTimeList.length);
        SetTeeTimes(teeTimeList);
        common.scrollWindowTop();
    }, []);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if(flg){
            history.push("/reserve/login");
            return;
        }
    }

    const onClickBack = () => {
        history.push("/reserve/golf/userInput");
    };

    const onClickReserve = (e) => {
        e.preventDefault();
        
        if (processing.current) {
            return;
        }
        processing.current = true;

        var reservedDate = new Date();

        var headCount = 0;
        var totalAmount = 0;
        teeTimes.forEach((data) => {
            headCount += data.playerCount;
            totalAmount += data.price * data.playerCount;
        });

        const loginUserInfo = store.getState().login.loginUserInfo;

        // 変更の場合この値が存在している
        let reserveNo = reserveCheckInfo.reservationNo;

        let contractNo = "";
        let remMemberNo = "";
        let remMemberName = "";
        let memberCd = "";
        var playDate;
        let reqFacility;
        //予約変更
        if(reserveCheckInfo.length !== 0 && reserveCheckInfo.MemberCode !== undefined){
            //日付指定
            playDate = new Date(reserveCheckInfo.playDate);
            reqFacility = reserveCheckInfo.golfCourseName;
            //jsonから取得（オーナーコードとメンバーコードに設定）
            let jsonTxt = reserveCheckInfo.reservationsDayInformationList[0].ntgGeneralPurposeItem;
            let jsonObj = JSON.parse(jsonTxt);
            let contractReq = jsonObj.ResortTrustInfomation.ownerMemberCode;
            contractNo = contractReq;
            if(reserveCheckInfo.memberCode !== null && reserveCheckInfo.memberCode !== undefined && reserveCheckInfo.memberCode !== ""){
                memberCd = contractReq;
            }
        //新規予約
        }else{
            //日付指定
            playDate = new Date(playDate1);
            kaiinken.forEach((data) => {
                if (data.selected === true) {
                    if(reserver.ownerCheck){
                        memberCd = data.contractNo;
                    }
                    contractNo = data.contractNo;
                    remMemberName = data.kaiinName;
                    remMemberNo = data.id;
                    reqFacility = data.facility;
                }
            });
        }

        const req = {
            golfCourseID: plan.golfCourseID,
            playDate: `${playDate.getFullYear()}-${(playDate.getMonth()+1).toString().padStart(2,"0")}-${(playDate.getDate()).toString().padStart(2,"0")}`,
            ttbLoginUserID: login.memberCode,
            ttbPlanID: plan.planid,
            reservFamilyName: loginUserInfo.memberSei,
            reservFirstName: loginUserInfo.memberMei ,
            planName: plan.planname,
            familyName: reserver.familyName,
            firstName: reserver.firstName,
            familyNameKana: reserver.familyNameKana,
            firstNameKana: reserver.firstNameKana,
            email: reserver.email,
            addressPref: reserver.prefecture,
            contactPhoneNumber: reserver.phoneNumber,
            partyCount: groupNumber,
            headCount: headCount,
            remark: reserver.planRemark,
            ownerCode:contractNo,
            // hotelReservationNo: login.memberInfo[0].contractNo,
            memberCode: memberCd,
            teeTimeList: teeTimeList,
            reserveChangeNo: reserveNo,
            remMemberName:remMemberName,
            remMemberNo:remMemberNo,
            remGolfCourse:reqFacility,
            reqPlan:plan,
        };

        console.log(req)
        
        let reserveType = store.getState().reserveType;
        console.log("API呼び出し");
        if(reserveType == "real"){
            common.doPost(reserveApi, req, afterReserve);
        }
        if(reserveType == "request"){
            common.doPost(requestReserveApi, req, afterReserve);
        }
    };

    const afterReserve = (res) => {
        console.log("APIアフターメソッド実行");
        // デバッグ
        if(res.data.resultCode == 0){
            // 画面遷移
            history.push("/reserve/golf/complete");
        } 
        else if(res.data.resultCode == 99) {
            // 別コースの予約を登録実施。
            setOtherCourseCheck(false);
            window.scroll({top:0, behavior: 'smooth'})
        }
        else{
            if(changeReserveNo !== undefined && changeReserveNo !== null && changeReserveNo !== ""){
                setReserveChangeErrorMessage(false);
            }else{
                setErrorMessage(false);
            }
            window.scroll({top:0, behavior: 'smooth'})
        }
        console.log("ref設定解除");
        processing.current = false;
    }

    return (
        <div style={styles.top} >
            {reserveType === "reserve" ? 
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.link} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.link} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/searchResult"} style={styles.link}>検索結果</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/startTime"} style={styles.link} >スタート時間</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/userInput"} style={styles.link}>利用者入力</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="入力内容確認" style={styles.link} />
            </div>
            : 
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.link} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.link} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/bookingConfirmDetaile"} style={styles.link} >予約詳細確認</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                {golfLocation === "input" ?  null : <Link to={"/reserve/golf/changeStartTime"} style={styles.link} >スタート時間</Link>}
                {golfLocation === "input" ?  null : <Label label=">" style={styles.breadCrumbArrow} />}
                <Link to={"/reserve/golf/userInput"} style={styles.link}>利用者入力</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="入力内容確認" style={styles.link} />
            </div>
            }
            <div style={isWideTablet ? styles.base2 : styles.base}>
                <>
                    <div style={styles.planlist}>
                        {!errorMessage ?
                        <div style={{textAlign:"center",color:"red",marginBottom:30,fontSize:13}}>予約に失敗しました<br/>別プランで再度検索してください</div>
                        :null}
                        {!reserveChangeErrorMessage ?
                            <div style={{textAlign:"center",color:"red",marginBottom:30,fontSize:13}}>お手数ですが予約されているゴルフ場まで{isWideTablet ? <br /> : ""}お問い合わせください</div>
                        :null}
                        {!otherCourseCheck ?
                        <div style={{textAlign:"center",color:"red",marginBottom:30,fontSize:13}}>接続エラーが発生しました。<br/>お手数ですがHOME画面より再度お試しください。</div>
                        :null}
                        <PlanListConfirm label1={"ゴルフ場"} label2={golfArea} >
                        </PlanListConfirm>
                        <PlanListConfirm label1={"プラン"} label2={planName} >
                        </PlanListConfirm>
                        <PlanListConfirm label1={"プレー日"} label2={playDate} >
                        </PlanListConfirm>
                        <PlanListConfirm label1={"組数"} label2={`${groupNumber}組`} >
                        </PlanListConfirm>
                        <div style={isWideTablet ? styles.form2 : styles.form}>
                            <InputConfirmReserver
                                label1={"利用代表者"}
                                label2={"氏名（漢字）"}
                                label3={reserver.firstNameKana && reserver.firstName ? reserver.familyName + reserver.firstName : ""}
                                label4={"氏名（カナ）"}
                                label5={reserver.familyNameKana && reserver.firstNameKana ? reserver.familyNameKana + reserver.firstNameKana : ""}
                                label6={"性別"}
                                label7={reserver.gender ? reserver.gender : ""}
                                label8={"都道府県"}
                                label9={reserver.prefectureName ? reserver.prefectureName : ""}
                                label10={"メールアドレス"}
                                label11={reserver.email ? reserver.email : ""}
                                label12={"電話番号"}
                                label13={reserver.phoneNumber ? reserver.phoneNumber : ""}
                                label14={"備考"}
                                label15={reserver.planRemark ? reserver.planRemark : ""} />
                        </div>
                    </div>
                    <div>
                    </div>
                    {(() => {
                        const items = [];
                        for (let i = 0; i < teeTimes.length; i++) {
                            items.push(
                                <div>
                                    <div style={isWideTablet ? styles.form2 : styles.form}>
                                        <Confirmheader label={i + 1 + "組目"} />
                                        <InputConfirmStartTime
                                            label1="スタート時間"
                                            label2={(teeTimes[i].courseName) + "/" + (store.getState().reserveType === 'request' ? (Number(teeTimes[i].teeTime.substring(0,2)) + "時台") : (teeTimes[i].teeTime)) + "スタート"} />
                                        <Line style={isWideTablet ? styles.line2 : styles.line} key={"line0" + i} />
                                    </div>
                                    <div style={isWideTablet ? styles.form2 : styles.form}>
                                        <InputConfirmStartTime label1={"人数"} label2={(teeTimes[i].playerCount) + "人"} />
                                        <Line style={isWideTablet ? styles.line2 : styles.line} key={"line1" + i} />
                                    </div>
                                    <div style={isWideTablet ? styles.form2 : styles.form}>
                                        {teeTimes[i].playerList[0].undecided === true ?
                                            <InputConfirmUndecided
                                                label1={"利用者1"}
                                                label2={"未定"} /> :
                                            <InputConfirm
                                                label1={"利用者1"}
                                                label2={"氏名（漢字）"}
                                                label3={teeTimes[i].playerList.length !== 0 ? teeTimes[i].playerList[0].playerName : ""}
                                                label4={"氏名（カナ）"}
                                                label5={teeTimes[i].playerList.length !== 0 ? teeTimes[i].playerList[0].playerNameKana : ""}
                                                label6={"性別"}
                                                label7={teeTimes[i].playerList.length !== 0 ? teeTimes[i].playerList[0].genderType : ""} />
                                        }
                                        <Line style={isWideTablet ? styles.line2 : styles.line} key={"line2" + i} />
                                    </div>
                                </div>
                            )

                            for (let j = 1; j < teeTimes[i].playerList.length; j++) {
                                items.push(
                                    <div style={isWideTablet ? styles.form2 : styles.form}>
                                        {teeTimes[i].playerList[j].undecided === true ?
                                            <InputConfirmUndecided
                                                label1={"利用者" + (j + 1)}
                                                label2={"未定"} /> :
                                            <InputConfirm
                                                label1={"利用者" + (j + 1)}
                                                label2={"氏名（漢字）"}
                                                label3={teeTimes[i].playerList[j].playerName}
                                                label4={"氏名（カナ）"}
                                                label5={teeTimes[i].playerList[j].playerNameKana}
                                                label6={"性別"}
                                                label7={teeTimes[i].playerList[j].genderType} />
                                        }
                                        {(j == teeTimes[i].playerList.length - 1) && (i != teeTimes.length - 1) ? null :
                                            <Line style={isWideTablet ? styles.line2 : styles.line} key={"line3" + String(i) + String(j)} />
                                        }
                                    </div>
                                )
                            }
                        }
                        return <div> {items} </div>;
                    })()}
                </>
                <div style={styles.box}>
                    <Button buttonText="戻る" className={isWideTablet ? "backBtnSp" : "backBtnPc"} onClick={onClickBack} />
                    <Button buttonText={reserveType === "reserve" ? "この内容で予約する" : "この内容で変更する"} className={isWideTablet ? "useBtnSp" : "useBtnPc"} onClick={onClickReserve} />
                </div>
                <div style={styles.reservelinkDiv} >
                    <Link style={styles.reservelink} to="/reserve/golf/search" >ゴルフ検索TOPに戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <GolfFooterContainer />
            </div>
        </div >
    )
}

const styles = {
    heading: {
        fontSize: "1.5rem",
        backgroundColor: "rgb(111, 111, 111)",
        width: "100%",
        height: "60px",
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "50px",
        color: "white",
    },
    headingText: {
        lineHeight: "60px",
        display: "inline-block",
        margin: "0px",
        width: "80%",
        textAlign: "left",
    },
    top: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    base: {
        background: "rgba(245,245,245,0.94)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "70%",
    },
    base2: {
        background: "rgba(245,245,245,0.94)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "90%",
    },
    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "50px auto",
        width: "100%",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    reservelinkDiv: {
        display: "block",
        padding: "3px",
        color: "#6f6f6f",
        textAlign: "center",
        padding: "0px 0px 50px",
    },
    reservelink: {
        color: "#6f6f6f",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "20%",
        marginBottom: "50px",
    },
    breadCrumb2: {
        display: "none",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    form: {
        width: "70%",
        margin: "0px auto 50px",
    },
    form2: {
        width: "100%",
        margin: "0px auto 15px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "10px auto 0px",
    },
    line2: {
        width: "90%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "15px auto 0px",
    },
    footer: {
        color: "#ffffff",
        marginTop: "100px",
    },
    planlist: {
        paddingTop: "50px",
        paddingBottom: "25px",
    },
}

const mapStateToProps = (state) => {
    return {
        facility: state.facility,
        plan: state.plan,
        playDate1: state.playDate1,
        searchCriteria: state.searchCriteria,
        group: state.group,
        teeTimeList: state.teeTimeList,
        reserver: state.reserver,
        login: state.login,
        reserveCheckInfo: state.reserveCheckInfo,
        kaiinken:state.kaiinken,
        course: state.course,
        changeReserveNo: state.changeReserveNo,
        golfLocation:state.golfLocation
    };
};

export default connect(mapStateToProps, null)(GolfConfirmContainer);